import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export function handleError(window, console) {
  return function execute(error) {
    console.error(error);
    if (error.response.status === 401) {
      window.location = '/';
    }
    return Promise.reject(error);
  };
}

// globally handle 401 (authorization needed, usually because the session timed out) by redirecting to '/' for now
// since window.location.reload(); doesn't currently work to get us back to where we left off.
instance.interceptors.response.use(
  undefined,
  handleError(window, console),
);

export function httpProxy(http) {
  return {
    httpBasic(...args) { return http(...args); },
    httpGet(...args) { return http.get(...args); },
    httpPut(...args) { return http.put(...args); },
    httpPost(...args) { return http.post(...args); },
    httpDelete(...args) { return http.delete(...args); },
  };
}

export const {
  httpBasic, httpGet, httpPut, httpPost, httpDelete,
} = httpProxy(instance);
export default instance;
